import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import { useNavigate, useParams } from 'react-router-dom';

import Form from './Form';
import WaitReport from './WaitReport';

export default function Index() {
  const [reportData, setReportData] = useState(null);

  // {
  //  thread_id: 'thread_SwqFOjRbUTEEHbgvelZt5Bit',
  //  run_id: 'run_TukaL15v3UEIGKd7nxDtbV0P',
  // }

  const navigate = useNavigate();

  const { reportTemplateId } = useParams();

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={() => navigate(-1)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Generate Report
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {reportData ? (
          <WaitReport
            reportData={reportData}
            closeForm={() => {
              navigate(-1);
            }}
          />
        ) : (
          <Form
            reportTemplateId={reportTemplateId}
            setReportData={setReportData}
            closeForm={() => {
              navigate(-1);
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
